// extracted by mini-css-extract-plugin
export default {"stepperItem":"stepper-item_stepperItem__+UaBj","button":"stepper-item_button__8aYD5","pellet":"stepper-item_pellet__2bghX","label":"stepper-item_label__vqnKK"};